import _ from 'lodash';
import utilitiesService from '../../services/utilities_service';
import hInput from '../input/input.vue';
import hSingleSelect from '../single_select/single_select.vue';

export default{
  inject: ['$validator'],
  props: {
    value: null,
    countryCode: String,
    placeholder: String,
    name: String,
    validation: {
      default: ''
    }
  },
  data: data,
  created: created,
  methods: {
    onCountryCodeChange: onCountryCodeChange,
    onChange: onChange
  },
  components: {
    hInput,
    hSingleSelect
  }
}

function data(){
  return {
    countryCode$: null,
    showCountryCodes: false,
    countryCodesSelectConfig: {
      data: []
    },
    config: {
      alias: 'numeric',
      rightAlign: false,
      repeat: 10
    }
  };
}

function created(){
  let scope = this;
  utilitiesService.getCountryCodes().then(onResponse);

  function onResponse(response){
    let countryCodes = _.map(response.data.country_codes, mapCountryCode);

    scope.countryCode$ = getInitialCountryCode();
    scope.countryCodesSelectConfig.data = countryCodes;

    function mapCountryCode(countryCode){
      return {
        id: countryCode.value,
        text: countryCode.display
      };
    }

    function getInitialCountryCode(){
      if(!_.isEmpty(scope.countryCode)) return scope.countryCode;
      return (_.head(countryCodes) || {}).id;
    }
  }
}

function onCountryCodeChange(value){
  if(_.isEmpty(value)) return;
  this.countryCode$ = value;
  this.onChange();
}

function onChange(){
  this.$emit('changed', {
    number: this.value,
    countryCode: this.countryCode$,
    formatted: `+${this.countryCode$}${this.value}`
  });
}